import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import ResumableUploader from '@/components/ResumableUploader/';

export default {
  components: {
    ResumableUploader: ResumableUploader
  },

  data: function data() {
    return {
      innerConfig: {
        accept: 'video/mp4',
        options: {
          maxChunkRetries: 2
        },
        maxSize: 1.5 * 1024 * 1024 * 1024
      },
      fileList: []
    };
  },


  props: {
    config: Object,
    formValue: Object
  },

  computed: {
    uploaderConfig: function uploaderConfig() {
      return _extends({}, this.innerConfig, {
        validate: this.validate,
        onSuccess: this.onSuccess,
        onRemove: this.onRemove,
        onPreview: this.onPreview,
        fileList: this.fileList,
        uploadData: _.omit((this.config.params && this.config.params() || {}).data, 'local')
      });
    }
  },

  methods: {
    validate: function validate(file) {
      var _this = this;

      var showErrorMessage = function showErrorMessage(msg) {
        _this.$message.error(msg);
      };
      var message = {
        type: '仅支持上传MP4格式的文件'
      };
      var acceptFileTypes = this.innerConfig.accept.split(',').map(function (item) {
        return item.trim();
      });

      if (acceptFileTypes.indexOf(file.fileType) === -1) {
        showErrorMessage(message.type);
        return false;
      }

      return true;
    },
    onSuccess: function onSuccess(response) {
      var _this2 = this;

      if (response.code === 0) {
        this.formValue[this.config.prop] = response.data.file_path;
        // 放置所有uploader返回的内容
        this.formValue.file = response.data;
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this2.formValue[_this2.config.prop] = '';
          _this2.fileList = [];
        });
      }
    },
    onRemove: function onRemove() {
      this.formValue[this.config.prop] = '';
    },
    onPreview: function onPreview(file) {
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    }
  },
  mounted: function mounted() {}
};